import styled from 'styled-components';

export const DescriptionHoliday = styled.div`
  background-color: rgba(255, 254, 238, 1);
  margin-left: 20px;
  display: inline-block;
  position: relative;
  overflow: hidden;
  flex-grow: 1;
`;

export const DescriptionItemHoliday = styled.span<{
  widthHolidayWrapper: number;
  widthHoliday: number;
}>`
  color: rgb(228 86 43);
  border-radius: 10px;
  padding: 2px 10px;
  letter-spacing: 1px;
  font-family: 'TUV-Montserrat';
  display: inline-block;
  vertical-align: super;
  white-space: nowrap;
  vertical-align: middle;
  animation: infiniteLeftToRight
    ${({ widthHolidayWrapper, widthHoliday }) => {
      const defaultWidth = 1100,
        defaultSecond = 15;

      return (
        ((widthHolidayWrapper + widthHoliday - defaultWidth) * defaultSecond) / defaultWidth +
        defaultSecond +
        's'
      );
    }}
    linear infinite;
  transform: translateX(-100%);

  @keyframes infiniteLeftToRight {
    0% {
      transform: translateX(-100%);
    }

    100% {
      transform: translateX(
        ${({ widthHolidayWrapper, widthHoliday }) => {
          const widthPercent =
            widthHoliday > widthHolidayWrapper
              ? Math.floor(100 - ((widthHoliday - widthHolidayWrapper) * 100) / widthHoliday)
              : Math.floor((widthHolidayWrapper * 100) / widthHoliday);

          return widthPercent + '%';
        }}
      );
    }
  }
`;
